(function(angular, module) {var annualSurveyForm;

annualSurveyForm = function(moment, ModelService, ModelConfig) {
  'ngInject';
  return {
    restrict: 'E',
    templateUrl: 'programs/annualSurvey/form',
    scope: {
      program: '=',
      survey: '=',
      editable: '='
    },
    link: function(scope) {
      var survey;
      survey = scope.survey;
      scope.first_day = moment([survey.year - 1, 9, 1]);
      scope.last_day = moment([survey.year, 8, 30]);
      scope.config = ModelConfig.getModelDatapoints('annual_survey');
      scope.save = function(data) {
        return ModelService.patchModel(survey, data);
      };
      return scope.totalUnits = function() {
        return scope.dybForm.housing_units_completed.activeData + scope.dybForm.housing_units_rehabed.activeData;
      };
    }
  };
};

module.directive('annualSurveyForm', annualSurveyForm);
})(angular, angular.module("dybAnnualSurvey"));